/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TagCategory {
  None = 'None',
  Interests = 'Interests',
  Restrictons = 'Restrictons',
  InvestmentProducts = 'InvestmentProducts',
  InvestmentThemes = 'InvestmentThemes',
  InvestmentThemesCountry = 'InvestmentThemesCountry',
  ActivityReasons = 'ActivityReasons',
  TaskCategories = 'TaskCategories',
  NetWorth = 'NetWorth',
  Other = 'Other'
}
